import { routes } from '@app/router/routes'
import type { PiIconName } from '@uiKit/elements/PiIcon.vue'

export interface AppNavItem {
  label: string
  to: string
  icon: PiIconName
}

// Desktop rail order + icons from the "Side Menu - NEW" Figma frame (32590:74310). Wallet is
// intentionally not a primary item — it stays in the profile menu.
export const APP_PRIMARY_NAV: AppNavItem[] = [
  { label: 'Dashboard', to: routes.DASHBOARD, icon: 'th-large' },
  { label: 'Properties', to: routes.PROPERTIES, icon: 'building' },
  { label: 'Marketplace', to: routes.MARKETPLACE, icon: 'shopping-bag' },
  { label: 'Portfolio', to: routes.PORTFOLIO, icon: 'briefcase' },
]

// Guests have no wallet and no holdings — every nav surface (side rail,
// mobile drawer) hides these for them. Matches investor-app.
export const GUEST_HIDDEN_NAV_ROUTES: readonly string[] = [routes.WALLET, routes.PORTFOLIO]

export const APP_UTILITY_NAV: AppNavItem[] = [
  { label: 'Help & Support', to: routes.HELP, icon: 'question-circle' },
  // { label: 'Settings', to: routes.SETTINGS, icon: 'cog' },
]
